<template>
    <Teleport to="body">
        <BackPanel v-if="show" @click.self="handleBackPanelClick" class="flex items-center justify-center">
            <div 
            class="bg-white rounded-lg shadow-lg p-4 w-full sm:w-[80%] md:w-[60%] lg:w-[50%] max-h-[90%] overflow-hidden flex flex-col items-center cursor-default" 
            :class="ModalClass"
            @mousedown="handleModalMouseDown"
            @mouseup="handleModalMouseUp">
                <h2 class="text-lg sm:text-xl font-bold mb-4 text-center text-main" v-if="label">
                    <Translate :value="label"/>
                </h2>
                <div class="w-full h-full overflow-y-auto overflow-x-hidden">
                    <slot></slot>
                </div>
                <slot name="footer" v-if="CloseButton">
                    <div class="mt-4 flex gap-2 w-full justify-center">
                        <Button @click="close" Rounded>
                            <Translate value="$element$:close" />
                        </Button>
                    </div>
                </slot>
            </div>
        </BackPanel>
    </Teleport>
</template>

<script>
import Button from "@/components/Blocks/Button.vue";
import BackPanel from "@/components/Blocks/BackPanel.vue";
export default {
    name: 'Modal',
    emits: ['close'],
    components: {
        Button,
        BackPanel
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        ModalClass: {
            type: String,
            default: ''
        },
        CloseButton: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            mouseDownOnModal: false
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        handleBackPanelClick(event) {
            // Only close if the mouse wasn't pressed down on the modal
            if (!this.mouseDownOnModal && event.target === event.currentTarget) {
                this.close();
            }
            // Reset the flag after handling the click
            this.mouseDownOnModal = false;
        },
        handleModalMouseDown() {
            this.mouseDownOnModal = true;
        },
        handleModalMouseUp() {
            // Reset the flag when mouse is released on the modal
            // Use a small timeout to ensure click event is processed first
            setTimeout(() => {
                this.mouseDownOnModal = false;
            }, 0);
        }
    },
    watch: {
        show(newValue) {
            // Reset the flag when modal is closed/opened
            if (!newValue) {
                this.mouseDownOnModal = false;
            }
            if(newValue){
                document.body.style.overflow = 'hidden';
            }else{
                document.body.style.overflow = '';
            }
        }
    }
};
</script>